import PropTypes from "prop-types";
import { FiCheckCircle } from "react-icons/fi";
import { BiLogOut } from "react-icons/bi";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useUser } from "../../contexts/UserContext/UserContext";
import { setSuccessLogout } from "../../contexts/UserContext/actions";
import { logoutAdmin } from "../../helpers/apiClient";
import { useCarContext } from "../../contexts/CarContext";

const SidebarNavFooter = ({ collapsed = false, onNavigate }) => {
    const { dispatch, myCompanyData } = useUser();
    const history = useHistory();
    const { resetCarState } = useCarContext();
    const { t } = useTranslation("sidebar");

    const onboardingComplete = myCompanyData?.onboardingSteps?.completed !== false;

    const handleSignout = async () => {
        try {
            await logoutAdmin();
        } catch {
            // still clear UI if API fails
        }
        dispatch(setSuccessLogout());
        resetCarState();
        onNavigate?.();
        history.replace("/login");
    };

    const handleFinishSetup = () => {
        history.push("/onboarding");
        onNavigate?.();
    };

    return (
        <div
            className={`flex w-full flex-col items-center justify-center gap-1.5 px-2 2xl:gap-2 2xl:px-4 ${
                collapsed ? "" : "mt-auto"
            }`}>
            {!onboardingComplete && (
                <button
                    data-tour="sidebar-finish-setup"
                    className={`cursor-pointer justify-center rounded-lg border-none bg-white/95 p-1.5 font-semibold text-[#5D5DF6] transition-colors duration-300 ease-in-out hover:bg-white ${
                        collapsed ? "w-full" : "w-[90%] 2xl:w-3/4"
                    }`}
                    onClick={handleFinishSetup}
                    type="button"
                    title={t("finishSetup")}>
                    <div className="flex items-center justify-center gap-1.5 2xl:gap-2">
                        <FiCheckCircle className="text-lg 2xl:text-xl" aria-hidden="true" />
                        {!collapsed ? <span className="truncate text-xs 2xl:text-sm">{t("finishSetup")}</span> : null}
                    </div>
                </button>
            )}
            <button
                className={`cursor-pointer justify-center rounded-lg bg-indigo-400 p-1.5 text-white transition-colors duration-300 ease-in-out hover:bg-indigo-500 active:bg-white active:text-black ${
                    collapsed ? "w-full" : "w-[90%] 2xl:w-3/4"
                }`}
                onClick={handleSignout}
                type="button"
                title={t("logout")}>
                <div className="flex items-center justify-center gap-1.5 2xl:gap-2">
                    <BiLogOut className="mb-[2px] text-lg 2xl:text-xl" />
                    {!collapsed ? <span className="truncate text-xs 2xl:text-sm">{t("logout")}</span> : null}
                </div>
            </button>
        </div>
    );
};

SidebarNavFooter.propTypes = {
    collapsed: PropTypes.bool,
    onNavigate: PropTypes.func,
};

export default SidebarNavFooter;
